export default __webpack_public_path__ + "static/media/entsoe_fp_vision.a3c2866e.jpg";